export default __webpack_public_path__ + "static/media/mail_icon_2.6b2550fb.svg";